/*
 * @Description:
 * @Date: 2024-11-28 14:31:34
 */
export const fieldsToArr = (list, listKey, targetKey) => {
  const data = list.reduce((pre, cur) => {
    if (cur[listKey]?.length) {
      const values = fieldsToArr(cur[listKey], listKey, targetKey);
      [].push.apply(pre, values);
    } else {
      pre.push(cur[targetKey]);
    }
    return pre;
  }, []);
  return data;
};
export const fieldsToMapping = (list, listKey, targetKey) => {
  const data = list.reduce((pre, cur) => {
    if (cur[listKey]?.length) {
      const mapping = fieldsToMapping(cur[listKey], listKey, targetKey);
      pre = { ...pre, ...mapping };
    } else {
      pre[cur.url] = cur;
    }
    return pre;
  }, {});
  return data;
};
